<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-md="true"
    :is-loading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <div class="list" v-if="waybillInfo.DATE">
        <div
          class="item"
          :class="{ active: index % 2 }"
          v-for="(item, index) in items"
          :key="item"
        >
          <span class="title">{{ item.name }}:</span>
          <span class="value">{{ waybillInfo[item.value] }}</span>
        </div>
      </div>
      <div v-else class="text-center">
        <span class="text-danger">اطلاعاتی وجود ندارد !</span>
      </div>
    </div>
  </bita-modal>
</template>
<script>
import LabelValue from "./LabelValue";

export default {
  components: { LabelValue },
  props: {
    modalId: {},
    isLoading: {},
    title: {},
  },
  data() {
    return {
      waybillInfo: {},
      items: [
        {
          name: "نام استان مبدا",
          value: "MABDA_OSTAN_NAME",
        },
        {
          name: "نام شهر مبدا",
          value: "MABDA_SHAHR_NAME",
        },
        {
          name: "شماره برنامه",
          value: "SHOMAREH_BARNAMEH",
        },
        {
          name: "نام استان مقصد",
          value: "MAGHSAD_OSTAN_NAME",
        },
        {
          name: "نام شهر مقصد",
          value: "MAGHSAD_SHAHR_NAME",
        },
        {
          name: "تاریخ صدور",
          value: "DATE",
        },
      ],
    };
  },
  methods: {
    onCloseModal() {
      this.waybillInfo = {};
    },

    init({ requestDetail }) {
      const waybillInfo = requestDetail.request_ticket_detail.waybill_info || {};

      if (Object.keys(waybillInfo).length > 0) {
        waybillInfo.DATE =
          waybillInfo?.TIME_SABT + " " + waybillInfo?.TARIKH_SODOOR_PERSIAN;
        this.waybillInfo = waybillInfo;
      } else {
        this.waybillInfo = {};
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  display: flex;
  flex-direction: column;

  .item {
    display: flex;
    gap: 5px;
    padding: 8px 6px;
    border-radius: 3px;

    &.active {
      background-color: rgb(241, 240, 240);
    }

    .title {
      flex: 0 1 30%;
      color: #18a689;
    }
  }
}
</style>
